var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronBigDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.71,16.71h-1.41L3.29,8.71l1.41-1.41,7.29,7.29,7.29-7.29,1.41,1.41-8,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronBigDown);
export default __webpack_public_path__ + "static/1765206080/media/icon-chevron-big-down.2491db7b75d177d4cb10e8e8c59ec069.svg";
export { ForwardRef as ReactComponent };